import { render, staticRenderFns } from "./SettlementExternalView.vue?vue&type=template&id=e56364a8"
import script from "./SettlementExternalView.vue?vue&type=script&lang=js"
export * from "./SettlementExternalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports